import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Role',
    column_type: 'string',
    column_name: 'name',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
  kind_in: {
    column_type: 'enum',
    extra: {
      model_name: 'Role',
      options: ['super', 'application', 'custom'],
    },
    model_name: 'Role',
    column_name: 'kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'custom_permissions': { required: false, disabledUpdate: false },
  },
  'custom_permissions': {
    'user': { required: false, disabledUpdate: true },
    'account': { required: false, disabledUpdate: true },
    'fund': { required: false, disabledUpdate: true },
    'fund_value': { required: false, disabledUpdate: true },
    'trade_rule': { required: false, disabledUpdate: true },
    'trade': { required: false, disabledUpdate: true },
    'trade_apply_record': { required: false, disabledUpdate: true },
    'risk_assessment': { required: false, disabledUpdate: true },
    'risk_assessment_result': { required: false, disabledUpdate: true },
    'video_record': { required: false, disabledUpdate: true },
    'monthly_report': { required: false, disabledUpdate: true },
    'custodian_monthly_report': { required: false, disabledUpdate: true },
    'announcement': { required: false, disabledUpdate: true },
    'page': { required: false, disabledUpdate: true },
    'application': { required: false, disabledUpdate: true },
  },
  'custom_permissions.user': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.account': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'update_remark': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.fund': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.fund_value': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.trade_rule': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.trade': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.trade_apply_record': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.risk_assessment': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.risk_assessment_result': {
    'read': { required: false, disabledUpdate: true },
  },
  'custom_permissions.video_record': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.monthly_report': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.custodian_monthly_report': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.announcement': {
    'read': { required: false, disabledUpdate: true },
    'create': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
    'destroy': { required: false, disabledUpdate: true },
  },
  'custom_permissions.page': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
  'custom_permissions.application': {
    'read': { required: false, disabledUpdate: true },
    'update': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Role', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Role', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
